import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import styles from './Spinner.module.scss';

interface SpinnerProps {
  variant?: 'inline';
  size?: 'text';
  center?: boolean;
  className?: string;
}

export const Spinner = ({ variant, size, center, className }: SpinnerProps) => {
  const t = useTranslations('components.spinner');

  const spinnerClass = clsx(styles.spinner, className, {
    [styles.spinnerSizeText]: size === 'text',
    [styles.spinnerVariantInline]: variant === 'inline',
    [styles.spinnerCenter]: center,
  });

  return <span className={spinnerClass} role="status" aria-label={t('loading')} />;
};
